var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("el-table-column", {
    key: _vm.code,
    attrs: {
      label: _vm.name,
      "min-width": _vm.columnWidth,
      fixed: false,
      align: "center",
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (scope) {
          return [
            _c("ik-table-data-popup", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.checkEdit(
                    scope.$index,
                    _vm.code,
                    scope.row[_vm.code],
                    scope.row
                  ),
                  expression:
                    "checkEdit(scope.$index, code, scope.row[code], scope.row)",
                },
              ],
              ref: "input_" + scope.$index + "_" + "code",
              attrs: {
                line: scope.$index,
                code: _vm.code,
                name: _vm.name,
                "default-value": _vm.defaultValue,
                "popup-width": _vm.popupWidth,
                require: _vm.getRequire,
                url: _vm.url,
                "filed-list": _vm.filedList,
                "search-key": _vm.searchKey,
                searcher: _vm.searcher,
                "page-sign": _vm.pageSign,
                rules: _vm.rules,
              },
              on: {
                onFieldChange: _vm.onFieldChange,
                onPopupClick: _vm.onPopupClick,
              },
              model: {
                value: scope.row[_vm.code],
                callback: function ($$v) {
                  _vm.$set(scope.row, _vm.code, $$v)
                },
                expression: "scope.row[code]",
              },
            }),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.checkEdit(
                      scope.$index,
                      _vm.code,
                      scope.row[_vm.code],
                      scope.row
                    ),
                    expression:
                      "!checkEdit(scope.$index, code, scope.row[code], scope.row)",
                  },
                ],
              },
              [_vm._v(" " + _vm._s(scope.row[_vm.code]) + " ")]
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }